import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AccountService } from '@services/user-transversal/account.service';
import { DialogComponent } from '@components/dialog/dialog.component';
import { specialCharacterValidator } from '@validators/specialCharacterValidator';
import { numberExistValidator } from '@validators/numberExistValidator';
import { letterValidator } from '@validators/letterValidator';

@Component({
  selector: 'app-restore-pass',
  templateUrl: './restore-pass.component.html',
  styleUrls: ['./restore-pass.component.scss']
})
export class RestorePassComponent implements OnInit {

  public submitted = false;
  public passwordAccount: FormGroup;
  public token: string;
  public errorPassword: boolean = false;
  public tokenBack: string;
  public freshToken: string;

  constructor(
    public router: Router,
    public dialogRef: MatDialogRef<RestorePassComponent>,
    public _accountService: AccountService,
    private formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.createFormPasswordAccount();
  }

  get controlsValidators() { return this.passwordAccount.controls }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem("token-session") !== null && this.token !== undefined) {
        this.dialogRef.close(true);
        window.location.href = "/";
      }
    }
  }

  createFormPasswordAccount() {
    this.passwordAccount = this.formBuilder.group({
      password: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(15),
        numberExistValidator,
        letterValidator,
        specialCharacterValidator
      ])),
      repeatPassword: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(15),
        numberExistValidator,
        letterValidator,
        specialCharacterValidator
      ]))
    });
  }

  changePassword() {
    this.submitted = true;

    if (this.passwordAccount.invalid) {
      return;
    }

    if (this.passwordAccount.controls.password.value === this.passwordAccount.controls.repeatPassword.value) {
      this.errorPassword = false;

      this._accountService.updatePasswordTransversal(this.freshToken, this.passwordAccount.controls.password.value).subscribe((response: any) => {
        const token = this.tokenBack;
        this.resetPassword(token);
        this.saveDialog("success_pop.svg", "Contraseña actualizada", "Tu contraseña fue actualizada exitosamente", "Aceptar");
      }, (error: any) => {
        this.saveDialog("fail_pop.svg", "Ha ocurrido un error", "No se pudo actualizar tu contraseña", "Aceptar");
      });

    } else {
      this.errorPassword = true;
    };
  }

  resetPassword(token) {
    this._accountService.changePassword(token).subscribe(res => { })
  }

  saveDialog(icon: string, title: string, message: string, tetxButton: string) {
    if (isPlatformBrowser(this.platformId)) {
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '570px'
      });
      dialogRef.componentInstance.urlImg = icon;
      dialogRef.componentInstance.title = title;
      dialogRef.componentInstance.message = message;
      dialogRef.componentInstance.tetxButton = tetxButton;
      dialogRef.afterClosed().subscribe(result => {
        window.location.href = '/login';
      });
    }
  }
}
